// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UKik","top":"styles_top__3YuU4"};